import { render, staticRenderFns } from "./VersionActions.vue?vue&type=template&id=2fd78a6c"
import script from "./VersionActions.vue?vue&type=script&lang=js"
export * from "./VersionActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports